module.exports = __webpack_public_path__ + "static/da10a77ad563a2c20e170507eee744ae87c1dc5649163db955bff64e14d8e35f-9ad1560d5e98d28e9f058d767098af62.png";